import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import React from "react";


export interface CreateNewButtonProps {
    onClick: () => void;
    text: string;
}


export default function CreateNewButton(props: CreateNewButtonProps) {
    return (
        <>
            <Button
                variant="contained"
                startIcon={<AddIcon/>}
                size="medium"
                onClick={props.onClick}
                sx={{
                    px: 2,
                    display: {md: "flex"},
                    width: {xs: "100%", md: 300},
                }}
            >
                {props.text}
            </Button>
        </>
    );
}
